export function timezones(state) {
    return state.timezones;
}
export function quotes(state) {
    return state.quotes;
}